module.exports = __webpack_public_path__ + "img/upload-icon-red.6f7ba791.svg";